export const ACCOUNT_TYPE={
    STUDENT:"Student",
    INSTRUCTOR:"Instructor"
}
export const COURSE_STATUS={
    DRAFT:"Draft",
    PUBLISHED:"Published"
}